const createSwiper = require('../components/swiperFactory');
const deviceUtilities = require('../utilities/deviceUtilities');
const { handleLogoVisibility } = require('../product/productDetailStyles').methods;

const SLIDER_CONTAINER_SELECTOR = '.product-images-slider .swiper-container';
const PAGINATION_SELECTOR = '.product-images-slider .swiper-pagination';

/**
 * Init swiper slider.
 * If swiper slider already exists, it is not reinitialized and returns null
 *
 * @param {Element|string} productImageSwiper - HTMLElement or string (with CSS
 * Selector) of swiper container HTML element. Required.
 * @returns {Promise.<Object>} - Swiper instance
 */
async function swiperInit() {
    // Calculates available space to set fixed swiper images height
    var headerHeight = Math.round($('.page-header .header-banner').outerHeight());
    var infoSectionHeight = Math.round($('#product-info-primary-section').innerHeight());
    var availableHeight = window.innerHeight - headerHeight - infoSectionHeight;

    const moreThanOneSlide = $('.product-images-slider .swiper-container .swiper-slide').length > 1;
    if (moreThanOneSlide) {
        return createSwiper(SLIDER_CONTAINER_SELECTOR, {
            direction: 'vertical',
            slidesPerView: 1,
            slidesPerColumn: 1,
            spaceBetween: 0,
            grabCursor: true,
            mousewheel: false,
            updateOnWindowResize: true,
            watchOverflow: true,
            loop: false,
            height: availableHeight,
            speed: 350,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            on: {
                slideChangeTransitionEnd: function () {
                    handleLogoVisibility();
                }
            }
        });
    }
    return Promise.resolve(null);
}

module.exports = async function () {
    /* type {object} Swiper instance */
    var productImageSwiper = null;

    const newObserverForRecomm = new MutationObserver(function (mutations) {
        mutations.forEach(async function (mutation) {
            if (mutation.type === 'childList' && productImageSwiper) {
                newObserverForRecomm.disconnect();
                productImageSwiper.destroy();
                $(PAGINATION_SELECTOR).empty();
                productImageSwiper = await swiperInit();
            }
        });
    });

    if (deviceUtilities.isSmallerThan768()) {
        productImageSwiper = await swiperInit();
        handleLogoVisibility();
        const sliderContainer = productImageSwiper?.wrapperEl?.closest(SLIDER_CONTAINER_SELECTOR);
        newObserverForRecomm?.observe(sliderContainer, { childList: true, subtree: true });
    }

    window.addEventListener('resize', async function () {
        if (deviceUtilities.isSmallerThan768()) {
            if (!productImageSwiper) {
                productImageSwiper = await swiperInit();
            }
        } else if (productImageSwiper) {
            productImageSwiper.destroy();
            $(PAGINATION_SELECTOR).empty();
            productImageSwiper = null;
        }
    });
};
